<template>
  <div class="app-navbar-pages-unauth">
    <nav>
      <router-link
        v-for="option in pages"
        :key="option.name"
        :to="{name: option.redirectTo}"
        class="app-navbar-pages-unauth__links"
        :style="linksStyle(option)"
      >
        <va-button v-if="option.isButton" type="submit" :style="'margin: unset'">{{option.name}}</va-button>
        <span v-else>
          {{ option.name }}
        </span>
      </router-link>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'app-navbar-pages-unauth',
  data () {
    return {
      pages: [
        {
          name: 'Home',
          redirectTo: 'home',
          isButton: false,
        },
        {
          name: 'About',
          redirectTo: 'about',
          isButton: false,
        },
        {
          name: 'Services',
          redirectTo: 'all-services',
          isButton: false,
        },
        {
          name: 'Relaxation Protocol',
          redirectTo: 'relaxation-protocol',
          isButton: false,
        },
        {
          name: 'Contact',
          redirectTo: 'contact',
          isButton: false,
        },
        // {
        //   name: 'Login',
        //   redirectTo: 'login',
        //   isButton: true,
        // },
      ],
    }
  },
  methods: {
    linksStyle (option) {
      const style = {
        color: this.$themes.darkerGray,
      }
      if (this.$route.name === option.redirectTo || this.$route.path.includes(option.redirectTo)) {
        style['font-weight'] = 600
        style.color = this.$themes.primary
      }
      return style
    },
  },
}
</script>

<style scoped lang="scss">
.app-navbar-pages-unauth {
  display: flex;

  &__links {
    margin-left: 1rem;
    font-size: 1rem;

    &:hover {
      filter: brightness(85%);
    }
  }
}

@include media-breakpoint-down(md) {
  .app-navbar-pages-unauth {
    display: none !important;
  }
}
</style>
